/**
 * ActivityLog.ts
 *
 * 계정/캐릭터 활동 로그 (첫접속, 계정연동, 캐릭터 생성, 월드 접속, 퀘스트 완료 등).
 * 현재 서버가 없으므로 localStorage('terra_anima_activity_log')에 기록하며
 * 관리자 페이지의 "활동 로그" 탭에서 조회한다. 최대 MAX_ENTRIES건 유지.
 */

import { ApiClient } from './ApiClient';

export type ActivityType =
  | 'ACCOUNT_FIRST_LOGIN'
  | 'ACCOUNT_LINKED'
  | 'CHARACTER_CREATED'
  | 'WORLD_ENTERED'
  | 'QUEST_COMPLETED';

export interface ActivityLogEntry {
  ts: number;
  type: ActivityType;
  account: string;
  character?: string;
  message: string;
}

export const ACTIVITY_LOG_STORAGE_KEY = 'terra_anima_activity_log';
const MAX_ENTRIES = 1000;

export class ActivityLog {
  public static load(): ActivityLogEntry[] {
    try {
      const raw = localStorage.getItem(ACTIVITY_LOG_STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {
      console.warn('Failed to parse activity log', e);
    }
    return [];
  }

  public static log(type: ActivityType, account: string, message: string, character?: string): void {
    try {
      const list = this.load();
      list.push({ ts: Date.now(), type, account, character, message });
      localStorage.setItem(ACTIVITY_LOG_STORAGE_KEY, JSON.stringify(list.slice(-MAX_ENTRIES)));
      console.log(`📝 [ActivityLog] ${type} | ${account}${character ? ' | ' + character : ''} | ${message}`);
    } catch (e) {
      console.error('Failed to write activity log', e);
    }
    // 서버 백엔드에도 비동기 전송
    ApiClient.logActivity(type, message, character);
  }
}
